export default class FileTreeNode {
    constructor() {
        /** @type {FileTreeNode} */
        this._parent = null;
        /** @type {Array<FileTreeNode>} */
        this._children = [];
        this._data = null;
    }

    get parent() {
        return this._parent;
    }

    set parent(value) {
        this._parent = value;
    }

    get children() {
        return this._children;
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = value;
    }

    /**
     * Adds a child to this node. Also sets the parent of the child node to this node.
     * @param {FileTreeNode} value 
     */
    addChild(value) {
        value.parent = this;

        this._children.push(value);
    }

    /**
     * Removes child from this node
     * @param {FileTreeNode} value
     */
    removeChild(value) {
        const index = this._children.indexOf(value);
        if (index < 0) {
            console.warn(`Tried removing child that was not in the children array.`, value);
            return;
        }

        // cleanup children of child node
        this._children[index].removeChildren();

        // remove the child of this node
        this._children.splice(index, 1);
    }

    /**
     * Removes all children from this node
     */
    removeChildren() {
        for (let i = 0; i < this._children.length; i++) {
            const child = this._children[i];
            child.removeChildren();
        }

        this._children = [];
    }
}